import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from "../utils/shared";
import { MonacoCodeEditorComponent } from "./code-editor.component";
import { MonacoCodeEditorConfig, MONACO_CODE_EDITOR_CONFIG } from "./config";
import { IdeCodeEditorComponent } from "./wrapper/ide-code-editor";
import { TsFileLoaderService } from "./hooks/ts-file-loader.service";
import { TsPackageLoaderService } from "./hooks/ts-package-loader.service";

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    SharedModule,
  ],
  exports: [
    MonacoCodeEditorComponent,
    IdeCodeEditorComponent,
    SharedModule,
  ],
  declarations: [
    MonacoCodeEditorComponent,
    IdeCodeEditorComponent,
  ],
  providers: [
    TsFileLoaderService,
    TsPackageLoaderService,
  ]
})
export class CodeEditorModule {

  public static forRoot(config: MonacoCodeEditorConfig = {}): ModuleWithProviders {
    return {
      ngModule: CodeEditorModule,
      providers: [
        { provide: MONACO_CODE_EDITOR_CONFIG, useValue: config }
      ]
    };
  }

}
